<template>
    <div class="p-5 lg:p-4 bg-white w-full mb-auto border-t border-gray-200 flex flex-col md:flex-row justify-between">
        <div class="flex items-center mb-5 md:mb-0">
            <p class="text-sm">{{ $__('opportunities.table.footer.view') }}</p>

            <select @change="onChangeSelect" class="mx-4 rounded opportunity__select">
                <option v-for="(option) in this.itemsPerPageOptions" :value="option" :selected="option === itemsPerPage ? 'selected' : false ">{{ option }}</option>
            </select>

            <p class="text-sm">{{ $__('opportunities.table.footer.items_per_page') }}</p>
        </div>

        <div class="flex items-center justify-center lg:justify-between">
            <IconWrapper @click="goToStart" :disabled="this.currentPage === 1">
                <ArrowStart
                    :class="'opportunity__table__item__navigation_arrow'" />
            </IconWrapper>


            <IconWrapper class="ml-2" @click="goPrev" :disabled="this.currentPage === 1">
                <ArrowPrev
                    :class="'opportunity__table__item__navigation_arrow'" />
            </IconWrapper>

            <p class="text-sm mx-2">{{ this.currentPage }} {{ $__('opportunities.table.footer.of') }} {{ this.totalPages }}</p>

            <IconWrapper class="mr-2" @click="goNext" :disabled="this.currentPage === this.totalPages">
                <ArrowNext
                    :class="'opportunity__table__item__navigation_arrow'" />
            </IconWrapper>

            <IconWrapper @click="goToEnd" :disabled="this.currentPage === this.totalPages">
                <ArrowEnd
                    :class="'opportunity__table__item__navigation_arrow'" />
            </IconWrapper>
        </div>
    </div>
</template>

<script>
import ArrowPrev from '@/Components/Icons/ArrowPrev';
import ArrowNext from '@/Components/Icons/ArrowNext';
import ArrowStart from '@/Components/Icons/ArrowStart';
import ArrowEnd from '@/Components/Icons/ArrowEnd';
import IconWrapper from '@/Components/Icons/Wrapper';

export default {
    components: { ArrowStart, ArrowNext, ArrowPrev, ArrowEnd, IconWrapper },
    props: {
        itemsPerPageOptions: Array,
        itemsPerPage: Number,
        currentPage: Number,
        totalPages: Number
    },
    methods: {
        onChangeSelect(event) {
            this.$emit('changeItemsPerPage', event.target.value);
        },
        goToStart() {
            this.$emit('navigatePage', 1);
        },
        goPrev() {
            let page = this.$props.currentPage;
            page = page === 1 ? 1 : page - 1;

            this.$emit('navigatePage', page);
        },
        goNext() {
            let page = this.$props.currentPage;
            page = page === this.$props.totalPages ? this.$props.totalPages : page + 1;

            this.$emit('navigatePage', page);
        },
        goToEnd() {
            this.$emit('navigatePage', this.$props.totalPages);
        }
    }
}
</script>
